import { render, staticRenderFns } from "./mixMore.vue?vue&type=template&id=38390768&scoped=true"
import script from "./mixMore.vue?vue&type=script&lang=js"
export * from "./mixMore.vue?vue&type=script&lang=js"
import style0 from "./mixMore.vue?vue&type=style&index=0&id=38390768&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38390768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38390768')) {
      api.createRecord('38390768', component.options)
    } else {
      api.reload('38390768', component.options)
    }
    module.hot.accept("./mixMore.vue?vue&type=template&id=38390768&scoped=true", function () {
      api.rerender('38390768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/more/mixMore.vue"
export default component.exports